//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Rate, Popup, Loading } from "vant";
import global from "../../../static/js/global";
export default {
  components: {
    [Popup.name]: Popup,
    [Rate.name]: Rate,
    [Loading.name]: Loading
    // "app-header":Header,
  },
  data() {
    return {
      loging: true,
      evaluate: false,
      value: "",
      valueone: "5",
      valuetwo: "4",
      percentage: 60,
      list: {
        percentage: 0,
        orderList: []
      },
      orderProgress: {
        percentage: 0, //订单当前总进度0-100  0==开始  100==完成
        //进度阶段List
        orderList: []
      },
      Dictionaries: [], // 评分标签
      Dictionaries_list: [], // 用户选择的评价标签
      handleMan: "", // 如果pc未派单 这个值为null 用户进来不显示头部 不为null才显示
      userList: {}, // 派单信息数据集
      handleId: ""
    };
  },
  mounted() {
    //  alert(this.handleMan)
    //alert(this.$router.history.current.query.repairState)
    //  alert(this.$router.history.current.query.handleMan)
    this.handleMan = this.$router.history.current.query.handleMan;
    this.handleId = this.$router.history.current.query.handleId;
    this.isEvaluate();
    this.getAllListUser();
    this.getDictionaries();
    this.getUser();
  },
  methods: {
    // 点评价取消
    del() {
      this.evaluate = false;
    },
    // 获取基本信息
    getUser() {
      if (this.handleMan != null) {
        let userList = {};
        userList.handleMan = this.handleId;
        this.$http
          .post(global.host + "/repair/findOrderQuantity", userList)
          .then(
            function(res) {
              console.log("基本信息");
              console.log(res);
              this.userList = res.body.result;
              this.value = res.body.result.avgNum;
            },
            function(err) {
              console.log(err);
            }
          );
      }
    },
    // 判断 如果参数符合标准 就弹出评价先评价 如果已评价 就不改变
    isEvaluate() {
      if (
        this.$router.history.current.query.repairState == 2 ||
        this.$router.history.current.query.repairState == 3
      ) {
        this.evaluate = true;
      }
    },
    // 删除指定元素公共方法
    removeByValue(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          arr.splice(i, 1);
          break;
        }
      }
    },
    // 时间戳转换兼容判断机型
    formatDate(date, type) {
      if (date != undefined) {
        //兼容ios
        if (
          /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
          navigator.userAgent.indexOf("Safari") > -1
        ) {
          date = String(date).replace(/\-/g, "/");
        }
        var time = "";
        if (date.indexOf("-") != -1 || date.indexOf("/") != -1) {
          time = new Date(date);
        } else {
          time = new Date(JSON.parse(date));
        }
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        var isTime = "";

        function add0(m) {
          return m < 10 ? "0" + m : m;
        }
        switch (type) {
          case "Y-M-D hh:mm:ss":
            isTime =
              year +
              "-" +
              add0(month) +
              "-" +
              add0(date) +
              " " +
              add0(hours) +
              ":" +
              add0(minutes) +
              ":" +
              add0(seconds);
            break;
          case "M-D hh:mm:ss":
            isTime =
              add0(month) +
              "-" +
              add0(date) +
              " " +
              add0(hours) +
              ":" +
              add0(minutes) +
              ":" +
              add0(seconds);
            break;
          case "M-D hh:mm":
            isTime =
              add0(month) +
              "-" +
              add0(date) +
              " " +
              add0(hours) +
              ":" +
              add0(minutes);
            break;
          case "hh:mm:ss":
            isTime = add0(hours) + ":" + add0(minutes) + ":" + add0(seconds);
            break;
          case "hh:mm":
            isTime = add0(hours) + ":" + add0(minutes);
            break;
        }
        return isTime;
      }
    },
    // 兼容时间格式
    getTs(time) {
      var arr = time.split(/[- :]/),
        _date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]),
        timeStr = Date.parse(_date);
      return timeStr;
    },
    // 获取进度展示展示数据集
    getAllListUser() {
      this.list.orderList = [];
      this.$http
        .get(
          global.host +
            "repair/findHandleRecord?repairId=" +
            this.$router.history.current.query.repairId
        )
        .then(
          function(response) {
            console.log("进度数据");
            // alert(JSON.stringify(response));
            console.log(response);
            // demo
            this.loging = false;
            for (var i = 0; i < response.body.result.length; i++) {
              var data = {
                id: i, //当前阶段id
                title: response.body.result[i].handleStatus, //当前阶段订单标题
                context: response.body.result[i].handleDesc, //当前阶段订单内容
                dataTime: response.body.result[i].handleDate //当前阶段订单结束时间
              };
              this.list.orderList.push(data);
            }
            for (var i = 0; i < this.list.orderList.length; i++) {
              //每次进度之后时间戳
              var timestamp2 = this.formatDate(
                this.list.orderList[i].dataTime,
                "Y-M-D hh:mm:ss"
              );
              //开始时间戳
              var timestamp1 = this.formatDate(
                this.list.orderList[0].dataTime,
                "Y-M-D hh:mm:ss"
              );
              //之后时间戳减开始
              var num = this.getTs(timestamp1) - this.getTs(timestamp2);
              //获取到总共时间
              var second = num / 1000;
              //判断当前度是否大于等于0
              if (parseInt(second / 3600) <= 0) {
                //最小0
                this.list.orderList[i].top = 0;
              } else {
                //长度拼接
                this.list.orderList[i].top = parseInt(second / 3600) + "0";
              }
            }
            //计算当前进度的总长度
            //获取最后时间戳
            var timestamp4 = this.formatDate(
              this.list.orderList[this.list.orderList.length - 1].dataTime,
              "Y-M-D hh:mm:ss"
            );
            //获取开始时间戳
            var timestamp3 = this.formatDate(
              this.list.orderList[0].dataTime,
              "Y-M-D hh:mm:ss"
            );
            //计算时间戳之差
            let num1 = this.getTs(timestamp3) - this.getTs(timestamp4);
            //获取到总时长
            var second1 = num1 / 1000;
            //判断总长度是否大于等于0
            if (parseInt(second1 / 3600) <= 0) {
              //最小0
              this.list.percentage = 0;
            } else {
              //拼接总进度长度
              this.list.percentage = parseInt(second1 / 3600) + "0";
            }
            //判断进度总长是否超过600
            if (this.list.percentage > 600) {
              //总进度超过600减半
              for (var j = 0; j < this.list.orderList.length; j++) {
                //每个进度减半
                this.list.orderList[j].top = this.list.orderList[j].top / 2;
              }
              //总长度减半
              this.list.percentage = this.list.percentage / 2;
            }
            //记录总加了多少长度
            var nuber = 0;
            //判断每个进度之间不能少于70px,少于70px,赋值给最低70
            for (var j = 0; j < this.list.orderList.length; j++) {
              //开始第一个阶段不用高度
              if (j == 0) {
              } else {
                //判断高度是否大于70
                if (this.list.orderList[j].top < 70) {
                  // //小于70记录与70之间的差
                  // nuber = 70 - this.list.orderList[j].top + nuber;
                  //给本阶段赋值最少进度70
                  this.list.orderList[j].top = 70;
                  //本阶段加了长度，后面都得加上等长，循环加
                  for (var s = j; s < this.list.orderList.length; s++) {
                    //每个阶段循环增加
                    this.list.orderList[s].top =
                      this.list.orderList[s - 1].top + 70;
                  }
                  //总长度加每个进度之间的补差
                  this.list.percentage = this.list.orderList[
                    this.list.orderList.length - 1
                  ].top;
                }
              }
            }
          },
          function(err) {
            console.log(err);
          }
        );
    },
    // 获取字典
    getDictionaries() {
      this.$http
        .get(global.host + "repairMgr/findDictList?domain=REPAIR_SCOPE_LABEL")
        .then(
          function(res) {
            if (res.body.statusCode == 200) {
              this.Dictionaries = res.body.result;

              console.log(this.Dictionaries);
            }
          },
          function(err) {
            console.log(err);
          }
        );
    },
    // 点击保存字典值 切换颜色
    getSazd(item, e) {
      if (e.target.classList.contains("dictionaryColor")) {
        e.target.classList.remove("dictionaryColor");
        this.removeByValue(this.Dictionaries_list, item);
      } else {
        this.Dictionaries_list.push(item);
        e.target.classList.add("dictionaryColor");
      }
    },
    // 提交评价
    payment() {
      this.Dictionaries_list = this.Dictionaries_list.join(",");
      console.log(this.Dictionaries_list);
      let submitScore = {};
      submitScore.repairId = this.$router.history.current.query.repairId;
      submitScore.handleScode = String(this.valueone);
      submitScore.serviceScode = String(this.valuetwo);
      submitScore.scodeDesc = this.Dictionaries_list;
      this.$http.post(global.host + "repair/submitScore", submitScore).then(
        function(res) {
          console.log(res);
          if (res.body.statusCode == 200) {
            this.getAllListUser();
            this.getUser();
            this.evaluate = false;
          }
        },
        function(err) {
          console.log(err);
        }
      );
      console.log(submitScore);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/repairComponents/repairsOne.vue